export interface LumiereSection {
  id: string;
  label: string;
  headline: string;
  subline?: string;
  body: string;
  cta?: { text: string; href: string };
  subLink?: string;
  image: string;
}

export const lumiereSections: LumiereSection[] = [
  {
    id: "intro",
    label: "社長の放課後部",
    headline: "社長の\n放課後部",
    subline: "普段は言わない考えを、話してみる。\nそこから始まる、名刺で終わらない繋がり。",
    body: "20:00〜｜新宿｜体験入部 ¥9,500",
    cta: { text: "体験入部する", href: "#booking" },
    image:
      "https://readdy.ai/api/search-image?query=Bright%20minimalist%20shisha%20lounge%20interior%20with%20white%20and%20light%20gray%20sofas%20arranged%20around%20low%20tables%2C%20vivid%20cobalt%20blue%20accent%20cushions%20and%20small%20furniture%20pieces%2C%20large%20floor-to-ceiling%20windows%20with%20soft%20natural%20daylight%20flooding%20the%20space%2C%20elegant%20shisha%20pipes%20visible%20on%20tables%2C%20clean%20airy%20atmosphere%20with%20polished%20concrete%20floor%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20stylish%20contemporary%20interior%20photography&width=1800&height=1200&seq=hero-blue-01&orientation=landscape",
  },
  {
    id: "collection",
    label: "MEIBO — 名刺の話",
    headline: "名刺を交換した\n人の顔を、\n何人思い出せますか。",
    body: "接点は増えていくのに、関係は残らない。",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20lounge%20corner%20with%20plush%20light%20gray%20modular%20sofas%2C%20vivid%20cobalt%20blue%20throw%20pillows%20and%20side%20tables%2C%20large%20panoramic%20windows%20showing%20city%20skyline%20with%20soft%20daylight%2C%20shisha%20pipes%20arranged%20elegantly%20on%20a%20round%20table%2C%20glasses%20with%20refreshing%20drinks%2C%20minimalist%20white%20interior%20with%20subtle%20blue%20accents%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20interior%20photography&width=1800&height=1200&seq=hero-blue-02&orientation=landscape",
  },
  {
    id: "craft",
    label: "YORU — ある夜の話",
    headline: "仕事の話だけで\n終わる、あの\n寂しい夜にはしません。",
    body: "月に一度、シーシャ屋に集まる会があります。",
    image:
      "https://readdy.ai/api/search-image?query=Intimate%20bright%20lounge%20seating%20area%20with%20white%20upholstered%20sofas%20and%20vivid%20cobalt%20blue%20accent%20chairs%2C%20soft%20natural%20daylight%20through%20tall%20windows%2C%20a%20sleek%20shisha%20pipe%20prominently%20featured%20on%20a%20low%20table%20as%20the%20main%20subject%2C%20clean%20white%20walls%20and%20light%20gray%20carpet%2C%20airy%20and%20inviting%20atmosphere%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20contemporary%20interior%20photography&width=1800&height=1200&seq=hero-blue-03&orientation=landscape",
  },
  {
    id: "service",
    label: "RULE — この会のルール",
    headline: "この会には、\nルールが\nひとつだけあります。",
    body: "だからここは、素の話をしても大丈夫な場所です。",
    image:
      "https://readdy.ai/api/search-image?query=Serene%20minimalist%20lounge%20by%20a%20large%20window%20with%20soft%20white%20curtains%2C%20light%20gray%20sofa%20with%20cobalt%20blue%20cushions%2C%20natural%20afternoon%20light%20creating%20gentle%20shadows%2C%20elegant%20shisha%20pipes%20on%20a%20windowsill%2C%20small%20side%20table%20with%20a%20glass%20of%20water%2C%20white%20walls%20and%20polished%20light%20wood%20floor%2C%20peaceful%20clean%20atmosphere%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20airy%20interior%20photography&width=1800&height=1200&seq=hero-blue-04&orientation=landscape",
  },
  {
    id: "cta",
    label: "SHINRAI — 信頼の話",
    headline: "僕がこの会で\n作りたいのは、\n人脈ではなく信頼です。",
    subline: "「あの人に連絡しよう」が、作業じゃなくなる。",
    body: "名刺交換より大切なことが、この会にはあります。",
    cta: { text: "体験入部する", href: "#booking" },
    subLink: "体験入部 ¥9,500（シーシャ代・ドリンク2杯分込み）",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20airy%20gathering%20space%20in%20a%20contemporary%20lounge%20with%20multiple%20white%20and%20light%20gray%20seating%20areas%2C%20vivid%20cobalt%20blue%20coffee%20tables%20and%20accent%20pieces%2C%20large%20windows%20with%20warm%20daylight%2C%20shisha%20pipes%20and%20elegant%20drink%20glasses%20on%20tables%2C%20clean%20minimalist%20design%20with%20white%20walls%2C%20cheerful%20and%20stylish%20atmosphere%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20interior%20photography&width=1800&height=1200&seq=hero-blue-05&orientation=landscape",
  },
];